import React from 'react';
import { Home, About, Works, Posts, } from 'pages';
import {A} from 'hookrouter';

// 5 second delay test to see lazy loading
// const Aug252021 = React.lazy(() => {
//   return new Promise(resolve => setTimeout(resolve, 5 * 1000)).then(
//     () =>
//       import('pages/2021/Aug25')
//   );
// });

// I hate this but list of pages to lazy load
const Aug252021 = React.lazy(() => import('pages/2021/Aug25'));

const routes = {
  '/' : () => <Home/>,
  '/Works' : () => <Works/>,
  '/Posts' : () => <Posts/>,
  '/About' : () => <About/>,
  // '/About' : function() {return React.createElement(About, {})},

  '/Posts/2021/Aug25' : () => <Aug252021/>
};

//Data is the array of objects to be placed into the table
const posts2021 = [
  { fullname: '25 August 2021 Building this website', 
    date: '25 August 2021', 
    title: <A href='/Posts/2021/Aug25'>Building this Website</A>},
]

export default routes
export {posts2021}
